/**
 * @desc 创建说明
 */
import {
  AbortiveExplainEntity,
  AbortiveExplainForm
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateAbortiveExplainParameter = AbortiveExplainForm

const method = 'POST'
const url = '/trade/abortiveExplain/createOrUpdate'

export const createAbortiveExplainApi = (
  data?: CreateAbortiveExplainParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AbortiveExplainEntity>({
    method,
    url,
    data,
    ...config
  })
}

createAbortiveExplainApi.method = method
createAbortiveExplainApi.url = url
